import React from "react";
import {
  FormSelect,
  Row,
  Col,
  FormInput,
  Badge,
  Container,
  Card,
  CardBody,
  FormCheckbox,
  FormGroup,
  ListGroup,
  ListGroupItem,
  Button,
  Alert,
} from "../components/ui";
import { Link, matchPath } from "react-router-dom";
import { withRouter } from "../hooks/withRouter";
import Author from "../components/common/author";
import { Modal, ModalHeader, ModalBody } from "../components/ui";
import JoditEditor from "jodit-react";
import {
  getTradingUnit,
  createAlert,
  createFavoriteAlert,
  updateAlert,
  setrackingAlert,
  removeFavoriteAlert,
  getMemberAlerts,
  getWistiaConfig,
  createAlertUpdate,
  getMixedAlerts,
  getAlert,
} from "../api";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import "react-image-gallery/styles/css/image-gallery.css";
import ImageGallery from "react-image-gallery";
import { formatToLocalDate } from "../utils";
import { handleApiError } from "../utils/apiErrorHandler";
import { DotLoader } from "react-spinners";
import publisherStore from "../flux/publisherStore";

const editorConfig = {
  uploader: {
    url: "http://localhost:8181/pictureUpload",
  },
  toolbarAdaptive: false,
  buttons: [
    "source",
    "|",
    "bold",
    "strikethrough",
    "underline",
    "italic",
    "eraser",
    "|",
    "superscript",
    "subscript",
    "|",
    "ul",
    "ol",
    "|",
    "outdent",
    "indent",
    "|",
    "font",
    "fontsize",
    "brush",
    "paragraph",
    "|",
    "align",
    "undo",
    "redo",
  ],
  placeholder: "",
  readOnly: false,
};

const getParams = (pathname) => {
  if (!pathname || typeof pathname !== "string") {
    return {};
  }
  const matchBlog = matchPath(`/alerts/:postName`, pathname);
  return (matchBlog && matchBlog.params) || {};
};

const topicsType = [
  { key: "*", name: "All" },
  { key: "info", name: "Informational" },
  { key: "trade&opened", name: "Open Trade" },
  { key: "trade&closed", name: "Closed Trade" },
  { key: "tracking", name: "Tracking" },
];

class Alerts extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      alertType: false,
      units: [],
      selectedUnit: null,
      selectedDurability: 1,
      topicsSelected: ["*"],
      alerts: [],
      desc: "",
      image: "",
      currentPage: 0,
      contentType: false,
      wistiaConfig: null,
      updateMode: false,
      modal: false,
      attachments: [],
      publisherSelected: null,
      loading: false,
    };
    this.alertEditorRef = React.createRef();
  }

  componentDidMount = async () => {
    this.setState({ loading: true });
    const alertId = this.props.match?.params?.id;
    if (alertId) {
      await this.getSingleAlert(alertId);
    } else {
      this.reloadData();
      document.addEventListener("scroll", this.trackScrolling);
    }
  };

  getSingleAlert = async (alertId) => {
    let user;
    if (localStorage.getItem("user") !== null) {
      user = JSON.parse(localStorage.getItem("user"));
    }
    if (!user) {
      // user not logged in.
    } else {
      let alert = await getAlert(alertId);
      let alerts = [];
      alerts.push(alert.data);
      this.setState(
        {
          alerts: alerts,
          user: user,
          loading: false,
        },
        () => {
          window.scrollTo(0, 0);
        }
      );
    }
  };

  componentDidUpdate(prevProps, prevState) {
    const pathname = this.props.location?.pathname;
    const prevPathname = prevProps.location?.pathname;

    if (!pathname || !prevPathname) {
      return; // Exit early if pathname is not available
    }

    const currentParams = getParams(pathname);
    const prevParams = getParams(prevPathname);

    if (
      currentParams.postName &&
      currentParams.postName !== prevParams.postName
    ) {
      this.getSingleAlert(currentParams.postName);
    }
  }

  componentWillUnmount = () => {
    document.removeEventListener("scroll", this.trackScrolling);
  };

  trackScrolling = async () => {
    const wrappedElement = document.getElementById("post-wrapper");
    if (this.isBottom(wrappedElement)) {
      document.removeEventListener("scroll", this.trackScrolling);
      let nextPage = this.state.currentPage + 1;
      let alerts;
      let publisherId = "*";
      if (this.props.location?.state) {
        publisherId = this.props.location.state.analyst;
      }
      if (this.state.publisherSelected) {
        publisherId = this.state.publisherSelected;
      }
      if (!this.state.user) {
        alerts = await getMixedAlerts(
          publisherId,
          this.state.topicsSelected,
          10,
          nextPage
        );
      } else {
        alerts = await getMixedAlerts(
          publisherId,
          this.state.topicsSelected,
          10,
          nextPage
        );
      }
      let temp = this.state.alerts;
      let updated = temp.concat(alerts.data.items);
      this.setState(
        {
          alerts: updated,
          currentPage: nextPage,
        },
        () => {
          document.addEventListener("scroll", this.trackScrolling);
        }
      );
    }
  };

  isBottom(el) {
    return el && el.getBoundingClientRect().bottom <= window.innerHeight;
  }

  reloadData = async () => {
    let user;
    if (localStorage.getItem("user") !== null) {
      user = JSON.parse(localStorage.getItem("user"));
    }
    let alerts;
    let units;
    let wistiaConfig;
    let publisherId = "*";
    if (this.props.location?.state) {
      publisherId = this.props.location.state.analyst;
    }
    if (this.state.publisherSelected) {
      publisherId = this.state.publisherSelected;
    }
    if (user && (user.userRoleId === 1 || user.userRoleId === 3)) {
      const res = await getWistiaConfig();
      wistiaConfig = res.data;
      alerts = await getMixedAlerts(
        publisherId,
        this.state.topicsSelected,
        10,
        this.state.currentPage
      );
      units = await getTradingUnit();
      this.initVideoUpload(wistiaConfig);
    }
    if (user && user.userRoleId === 2) {
      alerts = await getMixedAlerts(
        publisherId,
        this.state.topicsSelected,
        10,
        this.state.currentPage
      );
    }
    if (!user) {
      alerts = await getMixedAlerts(
        publisherId,
        this.state.topicsSelected,
        10,
        this.state.currentPage
      );
    }
    this.setState(
      {
        alerts: alerts.data.items,
        wistiaConfig: wistiaConfig,
        units: units ? units.data : null,
        user: user,
        attachments: [],
        desc: "",
        image: "",
        entry: "",
        target: "",
        stop: "",
        loading: false,
      },
      () => {
        window.scrollTo(0, 0);
      }
    );
  };

  type = () => {
    this.setState({ alertType: !this.state.alertType });
  };

  publish = async () => {
    const data = {
      alertDurabilityId: this.state.selectedDurability,
      tradingUnitId: this.state.alertType ? this.state.selectedUnit : null,
      isInformational: !this.state.alertType,
      entry: this.state.entry,
      target: this.state.target,
      stopLoss: this.state.stop,
      content: this.state.desc,
      attachments: this.state.attachments,
    };
    if (this.state.updateMode) {
      data["alertId"] = this.state.updateAlert.id;
      let update = await createAlertUpdate(data);
      if (update && update.status >= 200 && update.status < 300) {
        this.setState({
          alertUpdated: true,
        });
      } else {
        const errorResponse = handleApiError(update, "Failed to update alert");
        this.setState({
          showError: true,
          errorText: errorResponse.message,
        });
      }
      this.reloadData();
    } else {
      const res = await createAlert(data);
      if (res && res.status >= 200 && res.status < 300) {
        this.setState(
          {
            currentPage: 0,
            alertCreated: true,
            showError: false,
          },
          () => {
            this.reloadData();
          }
        );
      } else {
        const errorResponse = handleApiError(res, "Failed to create alert");
        this.setState({
          showError: true,
          errorText: errorResponse.message,
        });
      }
    }
  };

  changeUnit = (event) => {
    this.setState({ selectedUnit: event.target.value });
  };

  changeType = (event) => {
    this.setState({ selectedDurability: event.target.value });
  };

  updateAlert = (alert) => {
    window.scrollTo(0, 0);
    this.setState({
      updateMode: true,
      alertCreated: false,
      alertUpdated: false,
      alertType: !alert.isInformational,
      entry: alert.entry,
      target: alert.target,
      stop: alert.stopLoss,
      updateAlert: alert,
      selectedUnit: alert.tradingUnit,
    });
  };

  initVideoUpload = (config) => {
    var self = this;
    window._wapiq = window._wapiq || [];
    window._wapiq.push((W) => {
      window.wistiaUploader = new W.Uploader({
        accessToken: config.accessToken,
        dropIn: "wistia_uploader-alt",
        projectId: config.projectId,
        projectName: config.projectName,
      });
      window.wistiaUploader.bind(
        "uploadembeddable",
        (file, media, embedCode, oembedResponse) => {
          self.setState({
            embeddedVideo: {
              mediaId: media.id,
              thumbnailUrl: media.thumbnail.url,
              embedCode: embedCode,
            },
          });
          this.state.attachments.push({
            attachmentTypeId: 2,
            mediaId: media.id,
            thumbnailUrl: media.thumbnail.url,
            embedCode: embedCode,
          });
        }
      );
    });
  };

  setDescription = (event) => {
    this.setState({ desc: event });
  };

  clear = () => {
    this.setState({
      updateMode: false,
      entry: 0,
      target: 0,
      stop: 0,
      updateAlert: null,
      selectedUnit: "Choose...",
    });
  };

  createFavoriteAlert = async (alert) => {
    this.state.alerts.forEach((a) => {
      if (a.id === alert.id) {
        a.isFavourite = alert.isFavourite ? false : true;
      }
    });
    this.setState({
      alerts: this.state.alerts,
    });
    if (alert.isFavourite) {
      await createFavoriteAlert(alert.id);
    } else {
      await removeFavoriteAlert(alert.id);
    }
  };

  trackTrade = async (alert) => {
    this.state.alerts.forEach((a) => {
      if (a.id === alert.id) {
        a.tracking = alert.tracking ? false : true;
      }
    });
    this.setState({
      alerts: this.state.alerts,
    });
    if (alert.tracking) {
      await setrackingAlert(alert.id, true);
    } else {
      await setrackingAlert(alert.id, false);
    }
  };

  showShare = (alert) => {
    this.state.alerts.forEach((a) => {
      if (a.id === alert.id) {
        a.showShare = !alert.showShare ? true : false;
      }
    });
    this.setState({
      alerts: this.state.alerts,
    });
  };

  toggleUpdates = (alert) => {
    this.state.alerts.forEach((a) => {
      if (a.id === alert.id) {
        a.updatesOpen = a.updatesOpen ? !a.updatesOpen : true;
      }
    });
    this.setState({
      alerts: this.state.alerts,
    });
  };

  toggleModal = () => {
    this.setState({
      modal: !this.state.modal,
    });
  };

  onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () =>
        this.setState({ src: reader.result })
      );
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  // If you setState the crop in here you should return false.
  onImageLoaded = (image) => {
    this.imageRef = image;
  };

  onCropComplete = (crop) => {
    this.makeClientCrop(crop);
  };

  onCropChange = (crop, percentCrop) => {
    // You could also use percentCrop:
    // this.setState({ crop: percentCrop });
    this.setState({ crop });
  };

  async makeClientCrop(crop) {
    if (this.imageRef && crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(
        this.imageRef,
        crop,
        "newFile.jpeg"
      );
      this.setState({ croppedImageUrl });
    }
  }

  getCroppedImg(image, crop, fileName) {
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    return new Promise((resolve, reject) => {
      const base64Image = canvas.toDataURL("image/jpeg");
      resolve(base64Image);
    });
  }

  confirmImage = () => {
    let attachment = {
      attachmentTypeId: 1,
      title: "Image",
      data: this.state.croppedImageUrl
        ? this.state.croppedImageUrl
        : this.state.src,
    };
    this.state.attachments.push(attachment);
    this.setState(
      {
        modal: false,
        attachments: this.state.attachments,
      },
      () => {
        this.setState({
          src: null,
          croppedImageUrl: null,
        });
      }
    );
  };

  removeAttachment = (att) => {
    if (att.attachmentTypeId === 1) {
      this.setState({
        attachments: this.state.attachments.filter((a) => a.data !== att.data),
      });
    }
    if (att.attachmentTypeId === 2) {
      // handling to remove video
    }
  };

  mapAttachments = (att) => {
    if (att.attachmentTypeId === 2) {
      return {
        embedUrl: att.mediaId,
        thumbnail:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcTCD7-zFxjl5EXkC5XKGn6xw0yxVb9L6Kng0A&usqp=CAU",
        renderItem: this._renderVideo.bind(this),
      };
    } else {
      return {
        original: att.url,
        thumbnail: att.url,
      };
    }
  };

  _renderVideo(item) {
    return <div className={"wistia_embed wistia_async_" + item.embedUrl}></div>;
  }

  closeTrade = async () => {
    const data = {
      closeAlert: true,
      alertId: this.state.updateAlert.id,
      content: this.state.desc === "" ? "Trade closed." : this.state.desc,
      attachments: this.state.attachments,
      entry: this.state.entry,
      target: this.state.target,
      stopLoss: this.state.stop,
    };
    if (this.state.updateMode) {
      let update = await createAlertUpdate(data);
      if (update && update.status >= 200 && update.status < 300) {
        this.setState({
          alertUpdated: true,
        });
      } else {
        const errorResponse = handleApiError(update, "Failed to close alert");
        this.setState({
          showError: true,
          errorText: errorResponse.message,
        });
      }
      this.reloadData();
    }
  };

  changeAlertFilter = (event) => {
    this.setState(
      { topicsSelected: event.target.value, currentPage: 0 },
      () => {
        this.reloadData();
      }
    );
  };

  clearFilters = () => {
    this.setState(
      {
        publisherSelected: null,
        currentPage: 0,
      },
      () => {
        this.reloadData();
      }
    );
  };

  selectPublisher = (event, id) => {
    this.setState(
      {
        currentPage: 0,
      },
      () => {
        this.setState({ publisherSelected: id }, () => {
          this.reloadData();
        });
      }
    );
  };

  render() {
    const { crop, src } = this.state;
    return this.state.loading ? (
      <div className="mainLoaderBlock">
        <DotLoader color="#36d7b7" />
        <label style={{ marginTop: 30 }}>Loading your content...</label>
      </div>
    ) : (
      <Container fluid className="main-content-container px-4">
        <Container
          style={{ paddingTop: 60 }}
          className="main-content-container px-4"
          id={"post-wrapper"}
        >
          <Modal isOpen={this.state.modal} toggle={this.toggleModal}>
            <ModalHeader toggle={this.toggleModal}>Image Upload</ModalHeader>
            <ModalBody>
              <div className="custom-file mb-3">
                <input
                  type="file"
                  className="custom-file-input"
                  id="customFile2"
                  onChange={this.onSelectFile}
                />
                <label className="custom-file-label" htmlFor="customFile2">
                  Select image ...
                </label>
                {src && (
                  <ReactCrop
                    src={src}
                    crop={crop}
                    ruleOfThirds
                    onImageLoaded={this.onImageLoaded}
                    onComplete={this.onCropComplete}
                    onChange={this.onCropChange}
                  />
                )}
                {src && (
                  <Button
                    className="btn-orange btn btn-accent"
                    onClick={this.confirmImage}
                  >
                    Confirm
                  </Button>
                )}
              </div>
            </ModalBody>
          </Modal>
          {this.state.updateMode && (
            <Alert className="mb-0">
              <i className="fa fa-info mx-2"></i>
              {`Updating alert created on ${formatToLocalDate(
                this.state.updateAlert.createdAt
              )}`}
            </Alert>
          )}
          {this.state.user != null && this.state.user.userRoleId !== 2 && (
            <Card small className="mb-3">
              <CardBody>
                <Row>
                  <Col lg={6}>
                    <FormCheckbox
                      toggle
                      small
                      checked={this.state.alertType}
                      onChange={this.type}
                    >
                      {this.state.alertType ? "Trade Alert" : "Informational"}
                    </FormCheckbox>
                    <JoditEditor
                      ref={this.alertEditorRef}
                      value={this.state.desc}
                      config={editorConfig}
                      tabIndex={1}
                      onBlur={(newContent) => this.setDescription(newContent)}
                    />
                  </Col>
                  <Col lg={6}>
                    <h6
                      style={{
                        display: "inline-block",
                        marginRight: 8,
                        marginLeft: 15,
                      }}
                    >
                      Attachments
                    </h6>
                    <span
                      style={{
                        display: "inline-block",
                        verticalAlign: "middle",
                      }}
                    >
                      <i className="fa fa-video mx-2 favorite-star"></i>
                      <i
                        className="fa fa-image mx-2 favorite-star"
                        onClick={this.toggleModal}
                      ></i>
                    </span>
                    <Row>
                      <Col lg={12}>
                        <div id="wistia_uploader-alt"></div>
                      </Col>
                    </Row>
                    <Row>
                      <ListGroup small flush className="list-group-small">
                        {this.state.attachments
                          .filter((att) => att.attachmentTypeId !== 2)
                          .map((att) => (
                            <ListGroupItem
                              key={att.data.length}
                              className="d-flex px-3"
                            >
                              <div
                                key={att.data.length}
                                className="blog-comments__item d-flex p-3"
                              >
                                <i
                                  className="material-icons suggested-remove"
                                  onClick={() => this.removeAttachment(att)}
                                >
                                  clear
                                </i>
                                <div className="blog-comments__avatar mr-3">
                                  <img src={att.data} alt={att.title} />
                                </div>
                              </div>
                            </ListGroupItem>
                          ))}
                      </ListGroup>
                    </Row>
                  </Col>
                </Row>
                {this.state.updateMode === false && (
                  <Row>
                    {this.state.alertType && (
                      <Col lg={3}>
                        <br />
                        <label htmlFor="feInputState">Ticker</label>
                        <FormSelect
                          id="feInputState"
                          onChange={this.changeUnit}
                          value={this.state.selectedUnit}
                        >
                          <option>Choose...</option>
                          {this.state.units.map((unit) => (
                            <option key={unit.id} value={unit.id}>
                              {unit.abbreviation}
                            </option>
                          ))}
                        </FormSelect>
                      </Col>
                    )}
                    {this.state.alertType && (
                      <Col lg={3}>
                        <br />
                        <label htmlFor="feInputState">Type</label>
                        <FormSelect
                          id="feInputState"
                          onChange={this.changeType}
                        >
                          <option>Choose...</option>
                          <option value={1}>Short</option>
                          <option value={2}>Long</option>
                        </FormSelect>
                      </Col>
                    )}
                  </Row>
                )}
                {this.state.alertType && (
                  <Row>
                    <Col lg={2}>
                      <br />
                      <label htmlFor="feInputState">Entry</label>
                      <FormInput
                        size="lg"
                        className="mb-3"
                        placeholder="0"
                        value={this.state.entry}
                        onChange={(text) =>
                          this.setState({ entry: text.target.value })
                        }
                      />
                    </Col>
                    <Col lg={2}>
                      <br />
                      <label htmlFor="feInputState">Target</label>
                      <FormInput
                        size="lg"
                        className="mb-3"
                        placeholder="0"
                        value={this.state.target}
                        onChange={(text) =>
                          this.setState({ target: text.target.value })
                        }
                      />
                    </Col>
                    <Col lg={2}>
                      <br />
                      <label htmlFor="feInputState">Stop Loss</label>
                      <FormInput
                        size="lg"
                        className="mb-3"
                        placeholder="0"
                        value={this.state.stop}
                        onChange={(text) =>
                          this.setState({ stop: text.target.value })
                        }
                      />
                    </Col>
                  </Row>
                )}
                {this.state.updateMode &&
                  !this.state.updateAlert.isInformational && (
                    <Button
                      theme="accent"
                      className="btn-orange"
                      onClick={this.closeTrade}
                    >
                      Close Trade
                    </Button>
                  )}
              </CardBody>
              <div className="area mb-2 mr-1">
                <div className="buttons">
                  {this.state.updateMode && (
                    <Button theme="" className="" onClick={this.clear}>
                      Clear
                    </Button>
                  )}
                  <Button
                    theme="accent"
                    className="btn-orange"
                    onClick={this.publish}
                  >
                    Publish
                  </Button>
                </div>
              </div>
              {this.state.showError && (
                <Alert className="mb-0">
                  <i className="fa fa-error mx-2"></i>
                  {this.state.errorText}
                </Alert>
              )}
              {this.state.alertUpdated && (
                <Alert className="mb-0">
                  <i className="fa fa-info mx-2"></i>Alert has been updated!
                </Alert>
              )}
              {this.state.alertCreated && (
                <Alert className="mb-0">
                  <i className="fa fa-info mx-2"></i>Alert has been created!
                </Alert>
              )}
            </Card>
          )}
          <div className="add-comment alert-container">
            <Row noGutters>
              {this.state.user && (
                <span className="d-flex mb-2">
                  <FormSelect
                    id="feInputState"
                    onChange={this.changeAlertFilter}
                  >
                    {topicsType.map((topic, id) => (
                      <option value={topic.key}>{topic.name}</option>
                    ))}
                  </FormSelect>
                </span>
              )}
              <Col lg="10">
                <div className="filters text-right">
                  {(publisherStore.getPublishers() || [])
                    .filter((p) => p.isHidden === false)
                    .map((publisher, idx) => (
                      <a
                        href="#"
                        key={idx}
                        className={
                          this.state.publisherSelected === publisher.id
                            ? "selected card-post__author-avatar card-post__author-avatar--small"
                            : "card-post__author-avatar card-post__author-avatar--small"
                        }
                        onClick={(e) => this.selectPublisher(e, publisher.id)}
                      >
                        <img
                          src={publisher.avatar.small}
                          alt={publisher.name}
                        />
                      </a>
                    ))}
                  <div className="button-wrapper">
                    <Button
                      theme="accent"
                      className="cancel"
                      onClick={this.clearFilters}
                    >
                      Clear all filters
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>
            <div className="comments">
              {this.state.alerts.map((alert) => (
                <React.Fragment>
                  <div className="comment-item white">
                    <Author
                      url={`/analyst/${alert.publisher.slug}`}
                      name={alert.publisher.name}
                      date={null}
                      avatar={alert.publisher.avatar.small}
                      badges={[
                        {
                          title:
                            alert.publisher.isFeaturedContributor === true
                              ? "Featured contributor"
                              : "Analyst",
                          badge:
                            alert.publisher.isFeaturedContributor === true
                              ? "badge-featured-analyst"
                              : "badge-analyst",
                        },
                        {
                          title: alert.isInformational
                            ? "Informational"
                            : "Alert",
                          badge: alert.isInformational
                            ? "badge-featured-analyst"
                            : "badge-analyst",
                        },
                      ]}
                      badgeImg={require("../images/bitcoin-live/verified.png")}
                      nameStyle={{
                        fontWeight: "bold",
                        fontSize: "14px",
                        textShadow:
                          "0 1px 4px rgba(255,255,255,0.3), 0 1px 4px rgba(0,0,0,0.15)",
                      }}
                    />
                    <div className="comment-status">
                      {this.state.user &&
                        alert.alertStatusId !== undefined &&
                        alert.alertStatusId === 1 && (
                          <div className="statusDiv">
                            <span className="alert-status-open">OPEN</span>
                            {/* {formatToLocalDate(alert.createdAt)} */}
                          </div>
                        )}
                      {this.state.user &&
                        alert.alertStatusId !== undefined &&
                        alert.alertStatusId === 2 && (
                          <div className="statusDiv">
                            <span className="alert-status-closed spaced">
                              CLOSED
                            </span>
                            {/* {formatToLocalDate(alert.createdAt)} */}
                          </div>
                        )}
                      {this.state.user &&
                        (alert.isInformational ||
                          alert?.alertStatusId === 1 ||
                          alert?.alertStatusId === 2) && (
                          <div>{formatToLocalDate(alert.createdAt)}</div>
                        )}
                      {this.state.user &&
                        alert.publisher.id === this.state.user.id && (
                          <div
                            size="xs"
                            className="mb-2 mr-1"
                            onClick={() => this.updateAlert(alert)}
                          >
                            <span className="text-light">
                              <i className="material-icons update-alert">
                                update
                              </i>
                            </span>{" "}
                          </div>
                        )}
                    </div>
                    <div className="alert-body">
                      <p className="comment-text">
                        {!this.state.user && (
                          <React.Fragment>
                            <br />
                            <br />
                            <div className="alerts-premium">
                              Alerts are available only to registered members.
                              Please check prices below.
                            </div>
                            <Link
                              to={"/prices"}
                              className="alerts-premium-linear"
                            >
                              Become A Member
                            </Link>
                          </React.Fragment>
                        )}
                        {this.state.user && !alert.content && (
                          <React.Fragment>
                            <br />
                            <br />
                            <div className="alerts-premium">
                              Please renew your membership to be able to read
                              the alerts.
                            </div>
                            <Link
                              to={"/user-profile"}
                              className="alerts-premium-linear"
                            >
                              My Billing Area
                            </Link>
                          </React.Fragment>
                        )}
                        {this.state.user && alert.content && (
                          <React.Fragment>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: alert.content,
                              }}
                            ></div>
                          </React.Fragment>
                        )}
                      </p>
                      <div className="gallery-wrapper">
                        {alert.attachments && alert.attachments.length > 0 && (
                          <ImageGallery
                            showPlayButton={false}
                            items={alert.attachments.map(this.mapAttachments)}
                          />
                        )}
                      </div>
                      <div>
                        <br />
                        <div>
                          {this.state.user &&
                            alert.content &&
                            alert.alertDurabilityId === 2 && (
                              <span className="mb-2 mr-1 alert-status-open">
                                LONG
                              </span>
                            )}
                          {this.state.user &&
                            alert.content &&
                            alert.alertDurabilityId === 1 && (
                              <span className="mb-2 mr-1 alert-status-closed">
                                SHORT
                              </span>
                            )}
                          {this.state.user &&
                            alert.content &&
                            alert.tradingUnit && (
                              <span className="mb-2 mr-1 alert-status-unit">{`${alert.tradingUnit.abbreviation} - ${alert.tradingUnit.name}`}</span>
                            )}
                        </div>
                        {alert.entry && (
                          <div className="alert-show-case">
                            <div className="d-flex flex-wrap">
                              <div class="mr-5 mt-2">
                                <label className="bl-label">Entry</label>
                                <input
                                  className="bl-input"
                                  disabled=""
                                  readonly=""
                                  value={alert.entry}
                                />
                              </div>
                              <div class="mr-5 mt-2">
                                <label className="bl-label">Target</label>
                                <input
                                  className="bl-input"
                                  disabled=""
                                  readonly=""
                                  value={alert.target}
                                />
                              </div>
                              <div class="mr-5 mt-2">
                                <label className="bl-label">Stop Loss</label>
                                <input
                                  className="bl-input"
                                  disabled=""
                                  readonly=""
                                  value={alert.stopLoss}
                                />
                              </div>
                            </div>
                          </div>
                        )}
                        <Row>
                          {this.state.user && alert.content && (
                            <div
                              style={{ position: "absolute" }}
                              className="social pull"
                            >
                              <Button
                                theme="accent"
                                className={
                                  alert.tracking ? "btn-green" : "btn-orange"
                                }
                                style={{
                                  marginRight: 20,
                                  marginBottom: 5,
                                  padding: "0.3625rem 0.5rem",
                                }}
                                onClick={() => this.trackTrade(alert)}
                              >
                                {alert.tracking
                                  ? "TRACKING TRADE"
                                  : "TRACK TRADE"}
                              </Button>
                            </div>
                          )}
                        </Row>
                        <Row style={{ zIndex: 1 }}>
                          <div className="social alert-favorite pull-right">
                            <span className="add-favorite">
                              {this.state.user && alert.content && (
                                <div className="link-social">
                                  <div class="rating">
                                    {alert.isFavourite ? (
                                      <span
                                        className="selected"
                                        style={{
                                          fontSize: "14px",
                                          marginRight: 2,
                                        }}
                                        onClick={() =>
                                          this.createFavoriteAlert(alert)
                                        }
                                      >
                                        ★
                                      </span>
                                    ) : (
                                      <span
                                        style={{
                                          fontSize: "14px",
                                          marginRight: 2,
                                        }}
                                        onClick={() =>
                                          this.createFavoriteAlert(alert)
                                        }
                                      >
                                        ☆
                                      </span>
                                    )}
                                    Favorite
                                  </div>
                                </div>
                              )}
                            </span>
                            {this.state.user && alert.content && (
                              <div
                                className="link-social dropdown-share"
                                style={{ marginBottom: "3px" }}
                                onClick={() => this.showShare(alert)}
                              >
                                <i
                                  className="material-icons share"
                                  style={{ marginRight: "4px" }}
                                >
                                  share
                                </i>
                                Share
                                <div
                                  style={{
                                    display: !alert.showShare
                                      ? "none"
                                      : "block",
                                    left: !alert.showShare ? "-150px" : "0px",
                                  }}
                                  className={
                                    !alert.showShare
                                      ? "dropdown-content"
                                      : "dropdown-content show-share"
                                  }
                                >
                                  {alert && (
                                    <FormGroup className="form-group">
                                      <label htmlFor="feCurrPass">URL:</label>
                                      <FormInput
                                        id="feNewPass"
                                        type="text"
                                        value={
                                          window.location.origin +
                                          "/alerts/" +
                                          alert.id +
                                          "?aid=" +
                                          alert.publisher.affiliateId
                                        }
                                      />
                                    </FormGroup>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        </Row>
                      </div>
                    </div>
                  </div>
                  <React.Fragment>
                    {this.state.user &&
                      alert.updates &&
                      alert.updates.length > 0 && (
                        <div className="show-hide-updates">
                          <div className="d-flex justify-content-center flex-wrap">
                            <Badge
                              style={{
                                zIndex: 999,
                                fontSize: 16,
                                cursor: "pointer",
                              }}
                              onClick={() => this.toggleUpdates(alert)}
                              className={`card-post__category badge-content-tag`}
                            >
                              <div class="text-center">
                                <span class="btn-transparent">
                                  {alert.updatesOpen
                                    ? "- Hide Thread"
                                    : "+ Show Thread (" +
                                      alert.updates.length +
                                      ")"}
                                </span>
                              </div>
                            </Badge>
                          </div>
                        </div>
                      )}
                    {this.state.user &&
                      alert.updates &&
                      alert.updatesOpen &&
                      alert.updates.map((update) => (
                        <Card className="update-container">
                          <Col lg={{ size: 12, offset: 0 }}>
                            <p>
                              <b>{formatToLocalDate(update.createdAt)}</b>
                            </p>
                            <p
                              className="comment-text"
                              dangerouslySetInnerHTML={{
                                __html: update.content,
                              }}
                            ></p>
                            <div className="gallery-wrapper">
                              {update.attachments.length > 0 && (
                                <ImageGallery
                                  showPlayButton={false}
                                  items={update.attachments.map(
                                    this.mapAttachments
                                  )}
                                />
                              )}
                            </div>
                            <br />
                            <br />
                            <br />
                            <div className="alert-show-case">
                              {update.entry && (
                                <div className="d-flex flex-wrap">
                                  <div class="mr-5 mt-2">
                                    <label className="bl-label">Entry</label>
                                    <input
                                      className="bl-input"
                                      disabled=""
                                      readonly=""
                                      value={update.entry}
                                    />
                                  </div>
                                  <div class="mr-5 mt-2">
                                    <label className="bl-label">Target</label>
                                    <input
                                      className="bl-input"
                                      disabled=""
                                      readonly=""
                                      value={update.target}
                                    />
                                  </div>
                                  <div class="mr-5 mt-2">
                                    <label className="bl-label">
                                      Stop Loss
                                    </label>
                                    <input
                                      className="bl-input"
                                      disabled=""
                                      readonly=""
                                      value={update.stopLoss}
                                    />
                                  </div>
                                </div>
                              )}
                            </div>
                          </Col>
                        </Card>
                      ))}
                  </React.Fragment>
                </React.Fragment>
              ))}
            </div>
          </div>
        </Container>
      </Container>
    );
  }
}

export default withRouter(Alerts);
